import $api from "../http";
import { TransactionsResponse } from "../models/response/TransactionsResponse";
import { TransferResponse } from "../models/response/TransferResponse";
import { StorageResponse } from "../models/response/StorageResponse";
import {AxiosResponse} from 'axios';
import { IUser } from "../models/IUser";

export default class UserService {
    static fetchUsers(): Promise<AxiosResponse<IUser[]>> {
        return $api.get<IUser[]>('/profile/users');
    }
    static async transactions(): Promise<AxiosResponse<TransactionsResponse[]>> {
        return $api.get<TransactionsResponse[]>('/profile/transactions');
    }
    static async storage(): Promise<AxiosResponse<StorageResponse[]>> {
        return $api.get<StorageResponse[]>('/profile/storage');
    }
    static async refundProduct(id:string): Promise<AxiosResponse<TransferResponse>> {
        return $api.post<TransferResponse>('/profile/storage/refund', {id});
    }
    static async unwrapKit(id:string): Promise<AxiosResponse<TransferResponse>> {
        return $api.post<TransferResponse>('/profile/storage/unwrap', {id});
    }
    static async transfers(receiver:string, amount:number): Promise<AxiosResponse<TransferResponse>> {
        return $api.post<TransferResponse>('/profile/transfer', {receiver, amount});
    }
    static async promocode(promocode:string): Promise<AxiosResponse<TransferResponse>> {
        return $api.post<TransferResponse>('/profile/promocode', {promocode});
    }
    static async getUsernameById(steamID64:string): Promise<AxiosResponse<TransferResponse>> {
        return $api.post<TransferResponse>('/user/get/username', {steamID64});
    }
    static async refreshUser(): Promise<AxiosResponse<{user: IUser}>> {
        return $api.get<{user: IUser}>('/user/get/data');
    }
}